// extracted by mini-css-extract-plugin
module.exports = {"title":"ParserRules_title__3O1sA","button":"ParserRules_button__3FlG6","actions":"ParserRules_actions__20QNL"};